export const VARIANTS = [
  "default",
  "buttonPrimary",
  "buttonSecondary",
] as const;
